import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import logo from "../../../assets/img/LOGO/HEIMDALL-HAUT-FILAIRE BLANC_02.png";
import logoBiotech from "../../../assets/img/LOGO/biotech-logo2.png";
import logoUp from "../../../assets/img/LOGO/upperside-logo3.png";

import HomeIcon from "@mui/icons-material/Home";
import LegendToggleIcon from "@mui/icons-material/LegendToggle";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authSelector } from "../../../features/auth/authSlice";
import { version } from "../../../common/utils/apiConstants";

import styles from "../../../styles/sidebar.module.css";
import filePath from "../../../assets/textFiles/CHANGELOG.fr-FR.md";
import { displaySelector } from "../../../features/display/displaySlice";
import ClockDisplay from "../clockDisplay/ClockDisplay";

const Sidebar = () => {
  const { isAuth, user } = useSelector(authSelector);

  const display = useSelector(displaySelector);

  const isDisableAutoFocus = true;

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const showChangeLogs = () => {
    setOpen(true);
  };

  const [changeLogTxt, setChangeLogTxt] = useState("");

  useEffect(() => {
    fetch(filePath)
      .then((response) => response.text())
      .then((data) => {
        setChangeLogTxt(data);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      var element = document.getElementById("sidebarId");
      var mainElem = document.getElementById("mainId");

      if (!element || !mainElem) {
        console.warn("Sidebar elements not found:", { element: !!element, mainElem: !!mainElem });
        return;
      }

      if (display.isDisplaySidebar) {
        element.style.display = "block";
        mainElem.style.marginLeft = "280px";
      } else {
        element.style.display = "none";
        mainElem.style.marginLeft = "0px";
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [display.isDisplaySidebar]);

  let navigate = useNavigate();

  return (
    <>
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" disableAutoFocus={isDisableAutoFocus}>
        <Box className={styles.boxChangeLogs}>
          <h4>Historique des versions</h4>
          <div className={styles.listLogs}>
            <ReactMarkdown>{changeLogTxt}</ReactMarkdown>
          </div>
        </Box>
      </Modal>

      {isAuth && (
        <nav id="sidebarId" className={styles.sidebar}>
          <Link to="/" className={styles.link}>
            <img src={logo} alt="Logo Biotech Dental" className={styles.logo} />
          </Link>

          <div className={styles.fontBiotech}>HEIMDALL</div>

          <div className={styles.subTitle}>SUPERVISION</div>

          <br />

          <div className={styles.clockContainer}>
            <ClockDisplay />
          </div>

          <List className={styles.navList}>
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate("/")}>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Accueil" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate("/monitoring");
                }}
              >
                <ListItemIcon>
                  <LegendToggleIcon />
                </ListItemIcon>
                <ListItemText primary="Espace monitoring" />
              </ListItemButton>
            </ListItem>

            {user?.roles?.includes("biotech-supervision-admin") && user?.hasItRole && (
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate("/adminspace");
                  }}
                >
                  <ListItemIcon>
                    <AdminPanelSettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Espace Administration" />
                </ListItemButton>
              </ListItem>
            )}
          </List>

          <div>
            <img src={logoBiotech} alt="logoBiotech" className={styles.logoBD} />
            <img src={logoUp} alt="logoUp" className={styles.logoUp} />
          </div>
          <span className={styles.version} onClick={() => showChangeLogs()}>
            {version}
          </span>
        </nav>
      )}
    </>
  );
};

export default Sidebar;
